import React from "react"
import ThemeTopLayout from "gatsby-theme-material-ui-top-layout/src/components/top-layout"

import { useMediaQuery } from "@mui/material"
import { GlobalStyles } from "../../styles/app.styles"
import { Helmet } from "react-helmet"

export default function TopLayout({ children, theme }) {
  const isMd = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true,
  })
  let sectionPadding = theme.sectionPadding

  if (isMd) {
    sectionPadding = "padding-top: 5em; padding-bottom: 5em;"
  }

  return (
    <>
      <Helmet>
        <link href="https://use.typekit.net/ruy4npj.css" rel="stylesheet" />
        {/*<link*/}
        {/*  href="https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;1,100;1,300;1,400;1,500;1,700&display=swap"*/}
        {/*  rel="stylesheet"*/}
        {/*/>*/}
      </Helmet>

      <ThemeTopLayout theme={{ ...theme, sectionPadding }}>
        <GlobalStyles />
        {children}
      </ThemeTopLayout>
    </>
  )
}
